export default {
    setSyaratJenis: (context: any, newVal: any): void => {
        context.commit('setSyaratJenis', newVal);
    }
};
